// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3Oe1d","range":"MonthRangeSwitch_range__1hYB1","disabled":"MonthRangeSwitch_disabled__3UOwB"};